import {GlobalStyles} from '@mui/material';
import React from 'react';

const styles = theme => ({
  'html, body': {
    fontFamily: theme.typography.fontFamily,
    height: '100%',
  },
  '#pl-root': {
    height: '100%',
    width: '100%',
  },
  // style for shift-drag-zoom
  '.ol-box': {
    background: (theme.vars || theme).palette.common.white,
    border: `1px dashed ${(theme.vars || theme).palette.primary.dark}`,
    boxSizing: 'border-box',
    opacity: 0.4,
  },
  a: {
    cursor: 'pointer',
  },
  img: {
    userDrag: 'none',
  },
  '.intercom-launcher-frame': {
    display: 'none !important',
  },
  '.sentry-error-embed-wrapper': {
    '& .btn': {
      background: `${(theme.vars || theme).palette.primary.main} !important`,
      border: `1px solid ${(theme.vars || theme).palette.primary.main} !important`,
      borderRadius: theme.shape.borderRadius,
    },
  },
});

const appGlobalStyles = <GlobalStyles styles={styles} />;

export default appGlobalStyles;
